import { AUTHENTICATION_STATE, ISessionHolder } from '../types/authentication';

export const isLoggedIn = (session: ISessionHolder) => session && session.state === AUTHENTICATION_STATE.LOGGED_IN
export const isLoginRequested = (session: ISessionHolder) => session && session.state === AUTHENTICATION_STATE.LOGIN_PROMPTED
export const isLoginVerifying = (session: ISessionHolder) => session && session.state === AUTHENTICATION_STATE.VERIFYING




// WEBPACK FOOTER //
// ./src/utils/authentication.ts